import { render, staticRenderFns } from "./AgentSilver.vue?vue&type=template&id=2fd6d8fb&scoped=true&lang=pug&"
import script from "./AgentSilver.vue?vue&type=script&lang=js&"
export * from "./AgentSilver.vue?vue&type=script&lang=js&"
import style0 from "./AgentSilver.vue?vue&type=style&index=0&id=2fd6d8fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd6d8fb",
  null
  
)

export default component.exports